export enum BikKey {
  BIK_NAVIGATION = 'BIK_NAVIGATION',
}

